export default "__VITE_ASSET__g18tSUgg__"